import { clsx } from 'clsx';
import { Icon } from '@shared/widgets';
import GobblerIcon from '@assets/icons/transactions/gobbler.svg';

interface IAvatarProps {
  className?: string;
}

export const Avatar = (props: IAvatarProps) => {
  return (
    <Icon
      icon={<GobblerIcon />}
      className={clsx('flex items-center justify-center bg-soft-black border border-primary-block-border rounded h-10 w-16', props.className)}
      color='white'
    />
  );
};
